<form
  (ngSubmit)="handleSubmitClick()"
  [formGroup]="form">
  <app-form-control [underlineInputStyle]="true">
    <input
      [formControl]="form.controls.email"
      appPrimengInputText
      pInputText
      placeholder="Adres e-mail"
      type="text" />
  </app-form-control>

  <p-button
    [disabled]="form.invalid"
    [fluid]="true"
    appPrimengButton
    label="Wyślij"
    size="large"
    type="submit" />
</form>
